import { ActionTypes } from "../constants";

export default function wallet(state = {}, action) {

  switch(action.type) {
    case ActionTypes.SET_WALLET_DATA:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}